import React from 'react';
import { Field } from 'react-final-form';
import AttachmentsEmployeeField from './AttachmentsEmployeeField';

const UploadEmployeeField = ({ name, validate }) => (
  <Field
    name={name}
    validate={validate}
    render={({ meta: { error } }) => <AttachmentsEmployeeField name={name} error={error} dataName={name} />}
  />
);

export default UploadEmployeeField;
